const submissionAction = {
    ACKNOWLEDGE_MODIFICATIONS : 'acknowledge modifications',

    ASSIGN_ACCOUNT : 'assign account',

    CHECK_CLEARANCE : 'check clearance',

    CLEAR_READY : 'clear ready',

    CLEAR_REFERRAL : 'clear referral',

    RETRACT_REFERRAL : 'retract referral',

    DECLINE_REFERRAL : 'decline referral',

    REFER : 'refer',

    COMPLETE_APPLICATION : 'complete application',

    COPY_PROPOSAL : 'copy proposal',

    COPY_QUOTE : 'copy quote',

    COPY_SUBMISSION : 'copy submission',

    SPLIT_SUBMISSION : 'split submission',

    CREATE_ACCOUNT : 'create account',

    CREATE_ENDORSEMENT : 'create endorsement',

    CREATE_PROPOSAL : 'create proposal',

    CREATE_QUOTE : 'create quote',

    DECLINE : 'decline',

    DELETE_PRE_DRAFT : 'delete pre draft',

    DETAILED_HISTORY : 'detailed history',

    DISABLE_AUTOMATION : 'disable automation',

    DISCARD_MODIFICATIONS : 'discard modifications',

    MODIFY_APPLICATION : 'modify application',

    MODIFY_CARRIER_DRAFT : 'modify carrier draft',

    MODIFY_RENEWAL_INDICATOR : 'modify renewal indicator',

    MODIFY_SUBMISSION : 'modify submission',

    MODIFY_BOUND_SUBMISSION : 'modify bound submission',

    MODIFY_SUBMISSION_EFFECTIVE_DATE : 'modify submission effective date',

    MODIFY_SUBMISSION_NEEDED_BY_DATE : 'modify submission neededBy date',

    MODIFY_SUBMISSION_EXPIRATION_DATE : 'modify submission expiration date',

    MODIFY_SUBMISSION_INSURED_NAME : 'modify submission insured name',

    MODIFY_SUBMISSION_POLICY_NUMBER : 'modify submission policy number',

    OPEN_CANCELLATION : 'open cancellation',

    OPEN_ENDORSEMENT : 'open endorsement',

    OPEN_POLICY_ISSUANCE : 'open policy issuance',

    PRINT_SUBMISSION : 'print submission',

    REQUEST_CANCELLATION : 'request cancellation',

    REVERT_TO_CLEAR : 'revert to clear',

    REWRITE_SUBMISSION : 'rewrite submission',

    SUBMIT_APPLICATION : 'submit application',

    SUBMIT_CANCELLATION : 'submit cancellation',

    SUBMIT_MODIFICATIONS : 'submit modifications',

    VALIDATE_ACCOUNT : 'validate account',

    VIEW_ACCOUNT_OVERVIEW : 'view account overview'

};

angular.module('gw-um-j2js')
    .constant('submissionAction', submissionAction);